import {
  createAllPptxComponentSchemasNarrowed
} from "./chunk-GDFBPBEM.js";
import {
  DEFAULT_PPTX_RENDERER_ID,
  PPTX_RENDERER_IDS,
  pptxComponentDefinitionName
} from "./chunk-Y2ODB5VW.js";

// src/schemas/generator.ts
import { Type } from "@sinclair/typebox";
import { latestVersion } from "@json-to-office/shared";
function createPluginVersionSchema(custom, entry, recursiveRef, isLatest) {
  const fields = {
    name: Type.Literal(custom.name),
    id: Type.Optional(Type.String()),
    enabled: Type.Optional(
      Type.Boolean({
        default: true,
        description: "When false, this component is filtered out and not rendered. Defaults to true."
      })
    ),
    // Omitting version selects the latest release at runtime. Explicit older
    // versions remain discriminated so their own props schema is enforced.
    version: isLatest ? Type.Optional(Type.Literal(entry.version)) : Type.Literal(entry.version),
    props: entry.propsSchema
  };
  if (entry.hasChildren) {
    fields.children = Type.Optional(Type.Array(recursiveRef));
  }
  return Type.Object(fields, {
    additionalProperties: false,
    description: entry.description ?? custom.name
  });
}
function generateUnifiedDocumentSchema(options = {}) {
  const { customComponents = [] } = options;
  const branches = PPTX_RENDERER_IDS.map(
    (renderer) => generateRendererSchema(
      customComponents,
      renderer,
      renderer !== DEFAULT_PPTX_RENDERER_ID
    )
  );
  return Type.Union(branches, {
    description: "Presentation definition, discriminated by the optional renderer field. Omitted renderer means pptxgenjs."
  });
}
function generateRendererSchema(customComponents, renderer, requireDiscriminator) {
  return Type.Recursive(
    (Self) => {
      const pluginSchemas = [];
      for (const custom of customComponents) {
        if (custom.versions.length > 0) {
          const latest = latestVersion(
            custom.versions.map((entry) => entry.version)
          );
          const versions = custom.versions.map(
            (entry) => createPluginVersionSchema(
              custom,
              entry,
              Self,
              entry.version === latest
            )
          );
          pluginSchemas.push(...versions);
        }
      }
      const standardSchemas = createAllPptxComponentSchemasNarrowed(
        Self,
        pluginSchemas,
        { renderer, requireDiscriminator }
      );
      const componentSchemas = [...standardSchemas, ...pluginSchemas];
      if (componentSchemas.length === 0) {
        return Type.Object({});
      }
      return Type.Union(componentSchemas);
    },
    // Named per renderer so the export keys `definitions` by a stable name.
    { $id: pptxComponentDefinitionName(renderer) }
  );
}

export {
  generateUnifiedDocumentSchema
};
//# sourceMappingURL=chunk-ULFG7UHX.js.map